<div class="main-header-left d-none d-lg-block">
    <div class="logo-wrapper" style="justify-content: center;">
        <!-- <a class="h-100" routerLink="/initial"><img class="h-100" src="assets/images/logo-bg-white.png" alt=""></a> -->
        <a class="h-100" ><img class="h-100" src="assets/images/logo-bg-white.png" alt=""></a>
        <!-- <a class="h-100" ><img class="h-100" src="assets/images/logo-bg-white-ant.png" alt=""></a> -->
    </div>
</div>
<div class="sidebar custom-scrollbar">
    <!-- <div class="sidebar-user text-center">
        <div><img class="img-60 rounded-circle" [src]="url? url:'/assets/images/user/1.jpg'" alt="#">
            <div class="profile-edit">
                <a>
                    <i class="icofont icofont-pencil-alt-5"><input class="upload" type="file"
                            (change)="readUrl($event)" /></i>
                </a>
            </div>
        </div>
        <h6 class="mt-3 f-14">NOMBRE DE USUARIO</h6>
        <p>ROL DE USUARIO.</p>
    </div> -->
    <ul class="sidebar-menu" *ngIf="firstLevel">
        <li *ngFor="let menuItem of menuItems" [ngClass]="{active: menuItem.active}">
            <!-- <ng-container *appRolePermissions="menuItem.component; type:'view'"> -->
            <a class="sidebar-header clickable" (click)="toggleActive(menuItem)" [class.active]="menuItem.active"
                *ngIf="menuItem.type!='a' && menuItem.version <= navServices.org.versionplat">
                <div class="cont-icon">
                    <app-feather-icons [icon]="menuItem.icon"></app-feather-icons>
                </div>
                <span>
                    {{menuItem.title}}
                    <span class="badge badge-{{menuItem.badgeType}} ml-3"
                        *ngIf="menuItem.badgeType">{{menuItem.badgeValue}}
                    </span>
                </span>
            </a>
            <!-- </ng-container> -->

        </li>
    </ul>
    <ul class="sidebar-menu" *ngIf="!firstLevel">
        <li (click)="backToFirst()">
            <a class="clickable">
                <span class="fa fa-angle-left"></span>
                Volver
            </a>
        </li>
        <!-- <ng-container *appRolePermissions="menuItem.component; type:'view'"> -->
        <li *ngFor="let menuItem of subMenuItems" [ngClass]="{active: menuItem.active}">
            <a class="sidebar-header clickable" (click)="toggleActive(menuItem)" [class.active]="menuItem.active"
                *ngIf="menuItem.type!='a'">
                <app-feather-icons [icon]="menuItem.icon"></app-feather-icons>
                <span>
                    {{menuItem.title}}
                    <span class="badge badge-{{menuItem.badgeType}} ml-3" *ngIf="menuItem.badgeType">
                        {{menuItem.badgeValue}}
                    </span>
                </span>
                <i class="fa fa-angle-right pull-right" *ngIf="menuItem.children &&menuItem.children.length >0"></i>
            </a>


            <!-- 2nd Level Menu -->
            <ul class="sidebar-submenu" [ngClass]="{'menu-open': menuItem.active, 'menu-close': !menuItem.active }"
                *ngIf="menuItem.children">
                <!-- <ng-container *appRolePermissions="menuItem.component; type:'view'"> -->
                <li *ngFor="let childrenItem of menuItem.children" [ngClass]="{active: childrenItem.active}">

                    <!-- Sub -->

                    <a href="javascript:void(0)" *ngIf="childrenItem.type === 'sub'"
                        (click)="toggleActive(childrenItem)">

                        <app-feather-icons *ngIf="childrenItem.icon" [icon]="childrenItem.icon"></app-feather-icons>
                        {{childrenItem.title}}
                        <span class="badge badge-{{childrenItem.badgeType}} pull-right" *ngIf="childrenItem.badgeType">
                            {{childrenItem.badgeValue}}
                        </span>
                        <i class="fa fa-angle-down pull-right"
                            *ngIf="childrenItem.children &&childrenItem.children.length >0"></i>
                    </a>
                    <ul class="sidebar-submenu"
                        [ngClass]="{'menu-open': childrenItem.active, 'menu-close': !childrenItem.active }"
                        *ngIf="childrenItem.children">
                        <!-- <ng-container *appRolePermissions="childrenItem.component; type:'view'"> -->
                        <li *ngFor="let subchildrenItem of childrenItem.children"
                            [ngClass]="{active: subchildrenItem.active}">

                            <!-- Sub -->

                            <a class="sidebar-header clickable" (click)="toggleActive(subchildrenItem)" *ngIf="
                                menuItem.type!='a'" [class.active]="subchildrenItem.active">

                                <i class="fa fa-circle"></i>{{subchildrenItem.title}} <span
                                    class="badge badge-{{subchildrenItem.badgeType}} pull-right"
                                    *ngIf="subchildrenItem.badgeType">{{subchildrenItem.badgeValue}}</span>
                                <i class="fa fa-angle-down pull-right"
                                    *ngIf="subchildrenItem.children && subchildrenItem.children.length >0"></i>
                            </a>
                            <!-- 4rd Level Menu -->

                            <ul class="sidebar-submenu" *ngIf="subchildrenItem.children">
                                <li *ngFor="let subchildrenSubItem of subchildrenItem.children"
                                    [ngClass]="{active: subchildrenSubItem.active}">
                                    <a class="sidebar-header clickable" (click)="toggleActive(subchildrenSubItem)"
                                        *ngIf=" menuItem.type!='a'" [class.active]="subchildrenSubItem.active">
                                        <i class="fa fa-circle"></i>
                                        {{subchildrenSubItem.title}}
                                        <span class="badge badge-{{subchildrenSubItem.badgeType}} pull-right"
                                            *ngIf="subchildrenSubItem.badgeType">
                                            {{subchildrenSubItem.badgeValue}}
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <!-- </ng-container> -->
                    </ul>
                </li>
                <!-- </ng-container> -->
            </ul>
        </li>
        <!-- </ng-container> -->
    </ul>
    <!-- Logout -->
<ul class="sidebar-menu">
    <li>
        <a class="sidebar-header clickable" >
            <div class="cont-icon">
                <app-feather-icons icon="log-out" (click)="authService.SignOut()"></app-feather-icons>
            </div>
            <span>
                Salir
            </span>
        </a>
    </li>
</ul>
</div>

<div class="conjuntos">
    <div class="cont centrado" data-toggle="modal" data-target="#change_property">
        <h4 class="text">
            <!-- Mis Conjuntos -->
            <!-- Mis Conjuntos -->
        </h4>
        <img class="icon-move centrado-h" src="/assets/images/conjuntos.gif" alt="">
    </div>
</div>

